import React, { useState, useEffect, useRef, use } from "react";
import DateConverter from "@heartinz/date_and_time_processor";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { CircularProgress, Select } from "@mui/material";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import Messages from "../../../constants/Messages";
import handleError from "../../../constants/handleError";
import GetServerLiveTime from "../../../constants/GetServerLiveTime";

import ViewSaleTransactions from "./viewSaleTransaction";
import { useAuth } from "../../../context/AuthProvider";
import { Link } from "react-router-dom";
import ProductSearchList from "../../../constants/ProductSearchList";
import {
  ChevronRightIcon,
  DownloadIcon,
  FilterAltIcon,
  PhoneIcon,
  SearchIcon,
  SpreadSheetIcon,
  UserIcon,
} from "../../../constants/Icons";

const SaleTransactions = ({ isActive }) => {
  const [errors, setErrors] = useState("");
  const { isUser } = useAuth();
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const serverTime = GetServerLiveTime();
  const [selectedFilter, setSelectedFilter] = useState("today");
  const [selectedStore, setSelectedStores] = useState("");
  const [showCustom, SetShowCustom] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [allStores, setAllStores] = useState([]);
  const [allSuggestions, setAllSuggestions] = useState([]);
  const [showStorePopup, setShowStorePopup] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const StoreSuggestionsRef = useRef(null);
  const suggestionRefs = useRef([]);
  const [selectedStoreDeta, setSelectedStoreDeta] = useState("");

  const dropdownRef = useRef();
  const debounceTimerRef = useRef(null);
  const controllerRef = useRef(null);

  const suggestionsRef = useRef(null);
  const customerSuggestionsRef = useRef(null);
  const [isCustomerLoading, setIsCustomerLoading] = useState(false);
  const [isCustomerModalOpen, setCustomerModalOpen] = useState(false);
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [customerSearchTerm, setCustomerSearchTerm] = useState("");
  const [customerSuggestions, setCustomerSuggestions] = useState([]);
  const [isCustomerData, setCustomerData] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const MAIN_STORE = {
    _id: "",
    title: isUser.title,
    stype: isUser.stype,
    email: isUser.email,
  };
  var obj = {
    label: isUser.title,
    value: isUser.storeId,
    stype: isUser.stype,
  };

  const [isPreLoading, setPreLoading] = useState(true);
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [saleMode, setSaleMode] = useState("");

  const [options, setOptions] = useState([]);
  const [isSelectedStore, setSelectedStore] = useState(obj);
  const storeSelectedRef = useRef(null);

  const [isSaleReportData, setSaleReportData] = useState([]);

  const [isSelectedOption, setSelectedOption] = useState("BYSELF");
  const modeSelectedRef = useRef(null);

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const currentDate = new Date();

  const previousDate = new Date(serverTime.getTime() - 1000);
  const [fromDate, setFromDate] = useState(previousDate);
  const [toDate, setToDate] = useState(serverTime);

  const calculateDate = (baseDate, offsetDays) => {
    const resultDate = new Date(baseDate);
    resultDate.setDate(resultDate.getDate() + offsetDays);
    return resultDate;
  };

  // const handleFromDateChange = ([selectedDate]) => {
  //   const formattedDate = formatDate(selectedDate);
  //   setFromDate(selectedDate);
  //   const toDateValue = new Date(toDate);
  //   if (selectedDate > toDateValue) {
  //     const newFromDate = new Date(toDateValue.getTime() - 1000); // toDate - 1 day
  //     setFromDate(newFromDate);
  //     return;
  //   }

  //   const minToDate = calculateDate(selectedDate, -64);
  //   const maxToDate = new Date(
  //     Math.min(calculateDate(selectedDate, 64), serverTime)
  //   );
  //   if (toDateValue < minToDate || toDateValue > maxToDate) {
  //     setToDate(selectedDate);
  //   }
  // };

  const handleSupplierSearch = (term) => {
    setCustomerSearchTerm(term);
    if (term.trim() === "") {
      setCustomerSuggestions([]);
      setCustomerData(null);
      return;
    }
    if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
    debounceTimerRef.current = setTimeout(async () => {
      try {
        setIsCustomerLoading(true);
        if (!checkNetwork()) return;
        controllerRef.current = new AbortController();
        const response = await AxiosInstance.get(
          `module/customer/search?searchtxt=${encodeURIComponent(term.trim())}`,
          { signal: controllerRef.current.signal },
        );
        setCustomerSuggestions(response.data.results || []);
        const data = { phone: "", name: "" };
        if (/^\d+$/.test(term.trim())) {
          data.phone = term.trim();
        } else {
          data.name = term.trim();
        }
        setCustomerData(data);
      } catch (error) {
        if (error.name !== "CanceledError" && error.name !== "AbortError") {
          handleError(error, showAlert);
        }
      } finally {
        setIsCustomerLoading(false);
      }
    }, 200);
  };

  const handleSelectCustomer = async (customer) => {
    try {
      if (!checkNetwork()) return;

      // 1. Get full supplier details
      const response = await AxiosInstance.get(
        `module/customer/details/${customer._id}`,
      );

      const fullCustomer = response.data.results;

      // 2. Update UI state
      setSelectedCustomer(fullCustomer.customerData);
      setCustomerData(fullCustomer.customerData);
      setCustomerSearchTerm("");
      setCustomerSuggestions([]);

      // ❌ REMOVE THIS BLOCK COMPLETELY
      // updateActiveCart((cart) => ({
      //   ...cart,
      //   customer: fullCustomer,
      // }));
      showAlert("success", "Supplier Added successfully.");
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleRemoveSupplier = async () => {
    // ✅ After successful API call, update UI
    setSelectedCustomer(null);
    setCustomerSearchTerm("");
    setShowCustomerDropdown(false);
    showAlert("success", "Supplier removed successfully.");
  };

  const handleFromDateChange = (newValue) => {
    if (!newValue) return;
    const selectedFrom = newValue.startOf("day");

    const maxAllowedTo = selectedFrom.add(64, "days");
    const finalMaxTo = maxAllowedTo.isAfter(dayjs(serverTime))
      ? dayjs(serverTime)
      : maxAllowedTo;

    setFromDate(selectedFrom.toDate());
    if (
      dayjs(toDate).isBefore(selectedFrom) ||
      dayjs(toDate).isAfter(finalMaxTo)
    ) {
      setToDate(finalMaxTo.toDate());
    }
  };

  // const handleToDateChange = ([selectedDate]) => {
  //   const fromDateValue = new Date(fromDate);
  //   const selectedToDate = new Date(selectedDate);

  //   if (selectedToDate.getTime() <= fromDateValue.getTime()) {
  //     const correctedFromDate = new Date(selectedToDate.getTime() - 1000); // toDate - 1 sec
  //     setFromDate(correctedFromDate);
  //   }
  //   setToDate(selectedDate);
  // };

  // const toDateMin = calculateDate(new Date(fromDate), -64);
  // const toDateMax = new Date(
  //   Math.min(calculateDate(new Date(fromDate), 64), serverTime)
  // );

  const handleToDateChange = (newValue) => {
    if (!newValue) return;
    const selectedTo = newValue.endOf("day");

    if (selectedTo.isBefore(dayjs(fromDate))) {
      setFromDate(selectedTo.startOf("day").toDate());
    }
    setToDate(selectedTo.toDate());
  };

  const toDateMin = fromDate;
  const toDateMax = dayjs(fromDate).add(64, "day").isAfter(dayjs(serverTime))
    ? dayjs(serverTime)
    : dayjs(fromDate).add(64, "day");

  const handleListStore = async () => {
    setPreLoading(true);
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`list-substore`);
      // const options = formatOptions(response.data.results, isUser.stype);
      const stores = response.data?.results || [];

      const mergedStores = [MAIN_STORE, ...stores];

      setAllStores(mergedStores);
      // setInputValue(MAIN_STORE.title);
      setSelectedStores("");
      // const userStore = options.find(
      //   (option) => option.value === isUser.storeId
      // );
      // setSelectedStore(userStore);
      // handleSaleReport();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setPreLoading(false);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (!value.trim()) {
      setSelectedStores("");
      setAllSuggestions(allStores);
      setShowStorePopup(false);
      return;
    }

    const filtered = allStores.filter((store) =>
      store.title.toLowerCase().includes(value.toLowerCase()),
    );

    setAllSuggestions(filtered);
    setShowStorePopup(true);
  };

  const handleSelectStores = (store) => {
    const displayText = `${store?.title} - ${store?.email}`;
    setInputValue(displayText);
    setSelectedStores(store?._id);
    setShowStorePopup(false);
    setSelectedStoreDeta(store);
  };

  const formatOptions = (data, userType) => {
    if (userType === "MAIN") {
      const mainOption = {
        label: data.title,
        value: data._id,
        stype: "MAIN",
      };

      const subOptions = data.subs.map((subStore) => ({
        label: subStore.title,
        value: subStore._id,
        stype: "SUB",
      }));

      const hubOptions = data.subs.reduce((acc, subStore) => {
        if (subStore.hubs && subStore.hubs.length > 0) {
          const hubs = subStore.hubs.map((hub) => ({
            label: hub.title,
            value: hub._id,
            stype: "HUB",
          }));
          return acc.concat(hubs);
        }
        return acc;
      }, []);

      return [mainOption, ...subOptions, ...hubOptions];
    }

    if (userType === "SUB") {
      const subOption = {
        label: data.title,
        value: data._id,
        stype: "SUB",
      };

      let hubOptions = [];
      if (data.hubs && data.hubs.length > 0) {
        hubOptions = data.hubs.map((hub) => ({
          label: hub.title,
          value: hub._id,
          stype: "HUB",
        }));
      }

      return [subOption, ...hubOptions];
    }

    if (userType == "HUB") {
      const hubOptions = {
        label: data.title,
        value: data._id,
        stype: "HUB",
      };
      return [hubOptions];
    }
    return [];
  };

  const getColor = (status) => {
    switch (status?.toLowerCase()) {
      case "main":
        return "bg-label-orange";
      case "sub":
        return "bg-label-peach";
      case "hub":
        return "bg-label-night";
      default:
        return "bg-label-secondary";
    }
  };

  const renderOptionLabel = ({ label, stype }) => {
    let marginRight;
    let fontWeight;
    let badgePadding;
    let fontSize;

    if (stype === "MAIN") {
      marginRight = "0px";
      fontWeight = "500";
      fontSize = "14.5px";
      badgePadding = "2px 8px";
    } else if (stype === "SUB") {
      marginRight = "2px";
      fontWeight = "400";
      fontSize = "14px";
      badgePadding = "2px 12px";
    } else if (stype === "HUB") {
      marginRight = "4px";
      fontWeight = "300";
      fontSize = "13.5px";
      badgePadding = "2px 14px";
    }

    return (
      <span
        style={{
          display: "flex",
          alignItems: "center",
          marginLeft: marginRight,
        }}
      >
        <span
          className={`badge rounded-pill ${getColor(stype)}`}
          style={{
            marginRight: "5px",
            padding: badgePadding,
          }}
        >
          {stype}
        </span>
        <span style={{ fontWeight, fontSize }}>- {label}</span>
      </span>
    );
  };

  const handleSelectStore = (selected) => {
    setSelectedStore(selected);
  };

  const validateForm = () => {
    const errors = {};
    if (!isSelectedStore) {
      errors.store = Messages.ERROR.EMPTY_STORE;
    }
    if (!isSelectedOption) {
      errors.mode = Messages.ERROR.FIELD_REQUIRED;
      modeSelectedRef.current?.focus();
    }
    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      const firstErrorField = Object.keys(errors)[0];
      switch (firstErrorField) {
        case "store":
          storeSelectedRef.current?.focus();
          break;
        case "MODE":
          modeSelectedRef.current?.focus();
          break;
        default:
          break;
      }
    }
    return Object.keys(errors).length === 0;
  };

  const handleSaleReport = async () => {
    // if (!validateForm()) return;
    setPreLoading(true);
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;

      var data = {
        // storeid: isSelectedStore.value,
        // mode: isSelectedOption,
        // salemode: saleMode,
        fromdate: encodeURIComponent(
          DateConverter.convertToTimeZone(
            fromDate.toISOString(),
            isUser?.timezone,
          ),
        ),
        todate: encodeURIComponent(
          DateConverter.convertToTimeZone(
            toDate.toISOString(),
            isUser?.timezone,
          ),
        ),
      };

      // build query dynamically
      let url = `module/reports/salesandreturns?fromdate=${data.fromdate}&todate=${data.todate}`;
      if (selectedCustomer) {
        url += `&customerId=${selectedCustomer._id}`;
      }
      if (selectedStore) {
        url += `&storeId=${selectedStore}`;
      }
      const response = await AxiosInstance.get(url);
      setSaleReportData(response.data.results);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setPreLoading(false);
      setBtnLoading(false);
    }
  };

  const exportToCSV = () => {
    if (!isSaleReportData?.combinedReportData?.length) {
      showAlert("warning", "No data available to export");
      return;
    }

    const paymentTotals = (isSaleReportData?.combinedReportData || []).reduce(
      (totals, item) => {
        totals.CASH += Number(item?.paymentMethod?.CASH) || 0;
        totals.CARD += Number(item?.paymentMethod?.CARD) || 0;
        totals.ONLINE += Number(item?.paymentMethod?.ONLINE) || 0;
        totals.UPI += Number(item?.paymentMethod?.UPI) || 0;
        totals.PAYLATER += Number(item?.paymentMethod?.PAYLATER) || 0;

        return totals;
      },
      {
        CASH: 0,
        CARD: 0,
        ONLINE: 0,
        UPI: 0,
        PAYLATER: 0,
      },
    );

    // 1. Headers
    const headers = `S No,Date,Voucher No,Name,Phone,Total Sale,Total Amount,Cash,Card,Online,UPI,PayLater,Remark`;

    const clean = (val) => (val ?? "").toString().replace(/[\r\n;]/g, " ");

    // 2. Rows

    const rows = isSaleReportData?.combinedReportData
      ?.map((item, index) => {
        const row = [
          index + 1,

          clean(
            `${
              DateConverter.ISOToDisplayFormat(
                DateConverter.convertToTimeZone(
                  item?.documentDate,
                  isUser?.timezone,
                ),
              ).date
            }`,
          ),
          clean(
            item?.documentType === "SALE"
              ? item?.saleno || "-"
              : item?.saleReturnNo || "-",
          ),
          clean(
            `${
              item?.documentType === "SALE"
                ? item?.saleto?.customername || "-"
                : item?.CustomerInfo?.name || "-"
            }
            `,
          ),
          clean(
            `${
              item?.documentType === "SALE"
                ? item?.saleto?.customerphone
                  ? `+91 ${item.saleto.customerphone}`
                  : "-"
                : item?.CustomerInfo?.phone
                  ? `+91 ${item.CustomerInfo.phone}`
                  : "-"
            }`,
          ),
          clean(CurrencyConverter.toCurrency(item?.totalamount || 0, "INR")),
          clean(
            CurrencyConverter.toCurrency(
              Number(item?.totalReturnAmount) || 0,
              "INR",
            ),
          ),
          clean(
            CurrencyConverter.toCurrency(
              Number(item?.paymentMethod?.CASH) || 0,
              "INR",
            ),
          ),
          clean(
            CurrencyConverter.toCurrency(
              Number(item?.paymentMethod?.CARD) || 0,
              "INR",
            ),
          ),
          clean(
            CurrencyConverter.toCurrency(
              Number(item?.paymentMethod?.ONLINE) || 0,
              "INR",
            ),
          ),
          clean(
            CurrencyConverter.toCurrency(
              Number(item?.paymentMethod?.UPI) || 0,
              "INR",
            ),
          ),
          clean(
            CurrencyConverter.toCurrency(
              Number(item?.paymentMethod?.PAYLATER) || 0,
              "INR",
            ),
          ),
          clean(item?.remarks || "-"),
        ];
        return row.join(",");
      })
      .join("\n");

    // 3. Total Row
    const totalRow = [
      "",
      "",
      "",
      "TOTAL",
      "",

      // Total Sale
      `${CurrencyConverter.toCurrency(
        isSaleReportData.saleReportSummary?.grandTotal || 0,
        "INR",
      )}`,

      // Total Return
      `${CurrencyConverter.toCurrency(
        isSaleReportData.returnSaleReportSummary?.totalReturnAmount || 0,
        "INR",
      )}`,

      // Total Cash
      `${CurrencyConverter.toCurrency(paymentTotals.CASH, "INR")}`,

      // Total Card
      `${CurrencyConverter.toCurrency(paymentTotals.CARD, "INR")}`,

      // Total Online
      `${CurrencyConverter.toCurrency(paymentTotals.ONLINE, "INR")}`,

      // Total UPI
      `${CurrencyConverter.toCurrency(paymentTotals.UPI, "INR")}`,

      // Total PayLater
      `${CurrencyConverter.toCurrency(paymentTotals.PAYLATER, "INR")}`,
    ].join(",");

    // 4. Summary Tax Section (in "Heading, Value" format)
    const summaryTaxSection = [
      ["Total Summary", "", ""],
      ["Sale", "Return Sale", "Adjustment"],
      [
        clean(
          CurrencyConverter.toCurrency(
            Number(isSaleReportData.saleReportSummary?.totalSoldPrice) || 0,
            "INR",
          ),
        ),
        clean(
          CurrencyConverter.toCurrency(
            Number(
              isSaleReportData.returnSaleReportSummary?.totalReturnAmount,
            ) || 0,
            "INR",
          ),
        ),
        clean(
          CurrencyConverter.toCurrency(
            Number(isSaleReportData.combinedReportSummary?.totalSoldPrice) || 0,
            "INR",
          ),
        ),
      ],
      ["", "", ""], // Empty row for spacing
      ["Tax Summary", "", ""],
      ["Sale Tax", "Return Sale Tax", "Tax Adjustment"],
      [
        clean(
          CurrencyConverter.toCurrency(
            Number(isSaleReportData.saleReportSummary?.totalTaxAmount) || 0,
            "INR",
          ),
        ),
        clean(
          CurrencyConverter.toCurrency(
            Number(isSaleReportData.returnSaleReportSummary?.totalTaxAmount) ||
              0,
            "INR",
          ),
        ),
        clean(
          CurrencyConverter.toCurrency(
            Number(isSaleReportData.combinedReportSummary?.totalTaxAmount) || 0,
            "INR",
          ),
        ),
      ],
    ]
      .map((row) => row.join(","))
      .join("\n");

    // 5. Combine everything
    const csvContent = [headers, rows, totalRow, "", summaryTaxSection].join(
      "\n",
    );

    const BOM = "\uFEFF";
    const blob = new Blob([BOM + csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const from = formatDate(fromDate);
    const to = formatDate(toDate);

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `SaleandReturnSaleReport_Report_${from}_to_${to}.csv`,
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleQuickFilter = (filter, page = 0) => {
    setSelectedFilter(filter);
    if (filter === "custom") {
      // Customize opt
      SetShowCustom(true);
      return;
    }

    // Filtered ranges
    let startDate, endDate;

    if (filter === "today") {
      const now = serverTime;
      startDate = new Date(now);
      startDate.setHours(0, 0, 0, 0);
      endDate = new Date(now);
      endDate.setHours(0, 0, 0, 999);
    } else if (filter === "yesterday") {
      const yesterday = serverTime;
      yesterday.setDate(yesterday.getDate() - 1);

      startDate = new Date(yesterday);
      startDate.setHours(0, 0, 0, 0);

      endDate = new Date(yesterday);
      endDate.setHours(23, 59, 59, 999);
    } else {
      ({ startDate, endDate } = DateConverter?.getDateRange(filter));
      startDate = new Date(startDate);
      endDate = new Date(endDate);
      endDate.setHours(0, 0, 0, 999);
    }

    setFromDate(startDate);
    setToDate(endDate);
    setFromDate(startDate);
    setToDate(endDate);

    SetShowCustom(false);
    // handleSaleReport( startDate, endDate);
  };

  const handleReset = async () => {
    setSelectedStore("");
  };

  const handleSelectOption = (event) => {
    const selected = event.target.value;
    setSelectedOption(selected);
  };

  const handleSuggestionNavigation = (e) => {
    if (!showStorePopup || allSuggestions.length === 0) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev < allSuggestions.length - 1 ? prev + 1 : 0,
      );
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev > 0 ? prev - 1 : allSuggestions.length - 1,
      );
    }

    if (e.key === "Enter") {
      if (activeIndex >= 0) {
        e.preventDefault();
        handleSelectStores(allSuggestions[activeIndex]);
      }
    }

    if (e.key === "Escape") {
      setShowStorePopup(false);
    }
  };

  const handleCustomerKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        Math.min(prev + 1, customerSuggestions.length - 1),
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();

      const trimmedSearch = customerSearchTerm.trim();

      const noSelection = highlightedIndex === -1;
      const hasExactMatch = customerSuggestions.some((customer) => {
        const nameMatch =
          customer.name.toLowerCase() === trimmedSearch.toLowerCase();
        const phoneMatch = customer.phone === trimmedSearch;
        return nameMatch || phoneMatch;
      });

      // if (noSelection && !hasExactMatch) {
      //   handleCustomerModalOpen();
      //   return;
      // }

      if (highlightedIndex >= 0) {
        const selected = customerSuggestions[highlightedIndex];
        handleSelectCustomer(selected);
        customerSuggestionsRef.current?.focus();
        setShowCustomerDropdown(false);
        setCustomerSearchTerm("");
        setHighlightedIndex(-1);
      }
    }
  };

  useEffect(() => {
    if (highlightedIndex >= 0 && suggestionRefs.current[highlightedIndex]) {
      suggestionRefs.current[highlightedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [highlightedIndex]);

  useEffect(() => {
    if (activeIndex >= 0 && suggestionRefs.current[activeIndex]) {
      suggestionRefs.current[activeIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [activeIndex]);

  const handleOutsideClick = (e) => {
    if (
      StoreSuggestionsRef.current &&
      !StoreSuggestionsRef.current.contains(e.target)
    ) {
      setShowStorePopup(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  useEffect(() => {
    handleSaleReport(fromDate, toDate);
    {
      isUser?.stype === "MAIN" ? handleListStore() : setAllStores([MAIN_STORE]);
    }
  }, []);

  const hasSelectedCustomer = !!selectedCustomer?._id;

  return (
    <div>
      <div className="page-wrapper">
        <div className="page-content">
          <div className="page-breadcrumb d-flex align-items-center paddingBottom">
            <div className="breadcrumb-title pe-3">Sale Transactions</div>
            <div className="ms-auto">
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-export dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <DownloadIcon /> Export
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" onClick={exportToCSV}>
                      <SpreadSheetIcon />{" "}
                      <span className="icon-text">Excel (CSV)</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="row g-3 align-items-end">
                    {/* {isUser?.stype==="MAIN" &&( */}
                    <div className="col-lg-2 col-12">
                      <div className="position-relative">
                        <div className="input-group" ref={StoreSuggestionsRef}>
                          <input
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            value={inputValue}
                            onFocus={(e) => {
                              e.target.select();
                              setAllSuggestions(allStores);
                              if (allSuggestions.length > 0)
                                setShowStorePopup(true);
                            }}
                            onChange={(e) => {
                              handleChange(e);
                              setActiveIndex(-1);
                            }}
                            onKeyDown={handleSuggestionNavigation}
                            placeholder="Search Outlet.."
                          />
                          <button className="input-group-text">
                            <SearchIcon />
                          </button>
                        </div>
                        {showStorePopup && allSuggestions.length > 0 && (
                          <ul
                            className="suggestions-list"
                            style={{ maxHeight: "150px" }}
                          >
                            {allSuggestions.map((store, index) => (
                              <li
                                key={store._id}
                                ref={(el) =>
                                  (suggestionRefs.current[index] = el)
                                }
                                onMouseDown={() => handleSelectStores(store)}
                                className={`suggestion-item ${activeIndex === index ? "active-suggestion" : ""}`}
                              >
                                {/* {store?.stype==="MAIN" &&(
                                <>
                              <span
                                  className={`badge rounded-pill ${getColor(
                                    store?.stype
                                  )}`}
                                >
                                  {store.stype}
                                </span>
                                <small> - </small></>)} */}
                                {store.title} -{" "}
                                <span className="badge badge-primary badge bg-label-sea rounded-pill">
                                  {store.email}
                                </span>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-2">
                      <div className="position-relative">
                        {/* ✅ IF SUPPLIER SELECTED */}
                        {hasSelectedCustomer ? (
                          <div className="d-flex align-items-center justify-content-between border rounded px-2 py-2 bg-light">
                            <div className="d-flex flex-wrap align-items-center gap-2">
                              <span className="fw-600">
                                <UserIcon iClass={"fs-0 text-dark me-1"} />
                                {selectedCustomer.name}
                              </span>

                              <span className="badge bg-label-blue">
                                <PhoneIcon iClass={"fs-9 text-muted me-1"} />
                                {selectedCustomer.phone}
                              </span>
                            </div>

                            <div className="d-flex align-items-center gap-3 border-0">
                              {/* Edit */}
                              {/* <i
                                className="ng ng-ng-edit-icon cursor-pointer text-primary  shadow-none"
                                onClick={() => openEditModal(selectedCustomer)}
                              ></i> */}

                              {/* Remove */}
                              <i
                                className="ng ng-ng-remove-icon cursor-pointer text-danger shadow-none"
                                onClick={handleRemoveSupplier}
                              ></i>
                            </div>
                          </div>
                        ) : (
                          <>
                            {/* 🔍 SEARCH INPUT */}
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search Customer..."
                                value={customerSearchTerm}
                                ref={customerSuggestionsRef}
                                onChange={(e) => {
                                  handleSupplierSearch(e.target.value);
                                  setShowCustomerDropdown(true);
                                  setHighlightedIndex(-1);
                                }}
                                // onKeyPress={handleKeyPress}
                                onKeyDown={handleCustomerKeyDown}
                                onFocus={() => {
                                  if (customerSuggestions.length > 0) {
                                    setShowCustomerDropdown(true);
                                  }
                                }}
                              />

                              <button
                                className={`input-group-text ${customerSearchTerm.trim() ? "bg-label-prime" : ""}`}
                                // disabled={!value.trim()}
                                // onClick={handleCustomerModalOpen}
                              >
                                <SearchIcon />
                              </button>
                            </div>

                            {/* ❌ NO DATA */}
                            {customerSearchTerm &&
                              customerSuggestions.length === 0 && (
                                <ul className="suggestions-list">
                                  <li className="suggestion-item text-muted">
                                    No supplier found
                                  </li>
                                </ul>
                              )}

                            {/* 📋 DROPDOWN */}
                            {showCustomerDropdown &&
                              customerSuggestions.length > 0 && (
                                <ProductSearchList
                                  suggest={customerSuggestions}
                                  suggestionRefs={suggestionRefs}
                                  handleSelect={handleSelectCustomer}
                                  activeIndex={highlightedIndex}
                                  type="customer"
                                />
                              )}
                          </>
                        )}
                      </div>
                    </div>
                    {/* )} */}

                    {/* {isUser?.stype==="MAIN" &&(
                    <div className="col-lg-2 mb-2 mb-lg-0 ">
                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="bx bx-filter-alt"></i>
                        </span>
                        <select
                          className="form-select"
                          onChange={(e) => setSelectedStores(e.target.value)}
                          value={selectedStore} // today will be selected by default
                        >
                          <option value="">Select Outlet</option>
                          {options?.map((it)=>(
                          <option key={it?._id} value={it?._id}>{it?.title}</option>))}
                        
                        </select>
                      </div>
                    </div>)} */}
                    {showCustom && (
                      <>
                        <div className="col-2">
                          <label className="form-label w-100">
                            From Date <span className="text-danger"> *</span>
                          </label>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              format="DD MMM YYYY"
                              value={dayjs(fromDate)}
                              maxDate={dayjs(serverTime)}
                              onChange={handleFromDateChange}
                              // onChange={(newValue) => {
                              //   if (!newValue) return;
                              //   handleFromDateChange([newValue.toDate()]);
                              // }}
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  size: "small",
                                  inputProps: { readOnly: true },
                                  onKeyDown: (e) => e.preventDefault(),
                                  sx: {
                                    "& .MuiInputBase-input": {
                                      cursor: "pointer",
                                    },
                                  },
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </div>
                        <div className="col-2">
                          <label className="form-label w-100">
                            To Date <span className="text-danger"> *</span>
                          </label>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              value={dayjs(toDate)}
                              minDate={dayjs(toDateMin)}
                              maxDate={dayjs(toDateMax)}
                              format="DD MMM YYYY"
                              onChange={handleToDateChange}
                              slotProps={{
                                textField: {
                                  className: "form-control",
                                  size: "small",
                                  inputProps: { readOnly: true },
                                  onKeyDown: (e) => e.preventDefault(),
                                  sx: {
                                    "& .MuiInputBase-input": {
                                      cursor: "pointer",
                                    },
                                  },
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </div>
                      </>
                    )}
                    {/* <div className="col-12">
                      <label className="form-label w-100">
                        Store <span className="text-danger"> *</span>
                      </label>
                      <Select
                        options={options}
                        onChange={handleSelectStore}
                        value={isSelectedStore}
                        ref={storeSelectedRef}
                        isSearchable
                        formatOptionLabel={renderOptionLabel}
                      />
                      {errors.store && (
                        <div className="invalid-feedback">{errors.store}</div>
                      )}
                    </div> */}

                    {/* <div className="col-lg-12">
                      <label className="form-label w-100">
                        Generated <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="form-select"
                        onChange={handleSelectOption}
                        ref={modeSelectedRef}
                        value={isSelectedOption}
                      >
                        <option value="">Select</option>
                        <option value="BYSELF">By Self</option>
                        {isUser.stype !== "HUB" && (
                          <option value="BYOWNED">By Owned</option>
                        )}
                      </select>
                      {errors.mode && (
                        <div className="invalid-feedback">{errors.mode}</div>
                      )}
                    </div> */}
                    {/* <div className="col-12">
                      <label className="form-label w-100">Sale Mode</label>
                      <select
                        className="form-select"
                        value={saleMode}
                        onChange={(e) => setSaleMode(e.target.value)}
                      >
                        <option value="">All</option>
                        <option value="INVOICE">Tax Invoice</option>
                        <option value="BILL">Bill Receipt</option>
                      </select>
                      {errors.salemode && (
                        <div className="invalid-feedback">
                          {errors.salemode}
                        </div>
                      )}
                    </div> */}
                    <div className="col-lg-2 mb-2 mb-lg-0 ">
                      <div className="input-group">
                        <span className="input-group-text">
                          <FilterAltIcon />
                        </span>
                        <select
                          className="form-select"
                          onChange={(e) => handleQuickFilter(e.target.value)}
                          value={selectedFilter} // today will be selected by default
                        >
                          <option value="today">Today</option>
                          <option value="yesterday">Yesterday</option>
                          <option value="thisWeek">This Week</option>
                          <option value="lastWeek">Last Week</option>
                          <option value="thisMonth">This Month</option>
                          <option value="lastMonth">Last Month</option>
                          <option value="custom">Custom</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-3 float-end">
                      <div className="d-grid col-lg-6">
                        {isBtnLoading ? (
                          <button
                            className="btn btn-primary pb-0 text-right"
                            disabled
                          >
                            <CircularProgress
                              size={22}
                              className="text-white"
                            />
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-primary"
                            id="salesreportbtn"
                            onClick={() => handleSaleReport(fromDate, toDate)}
                          >
                            Generate <ChevronRightIcon />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="card p-3">
                <ViewSaleTransactions
                  isData={isSaleReportData}
                  isPreLoading={isPreLoading}
                  isActive={isActive}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaleTransactions;
